import React from 'react'
import styled from 'styled-components'
import IEventedComponent, { messageTypes } from '../components/IEventedComponent'
import colours from '../lib/colours'
import { MobileDeviceWidth } from '../lib/constants'
import { SidebarToggledEvent } from '../lib/messages'
import IconControl from './icon-control'

const ToggleContainer = styled.div`
  height: 40px;
  width: 40px;
  position: absolute;
  z-index: 1;
  bottom: 30px;
  left: 0;
  background: white;
  cursor: pointer;
  border-radius: 0 8px 8px 0;
  color: ${colours.darkPurple};
  :hover {
    color: ${colours.mediumPurple};
  }
  @media (max-width: ${MobileDeviceWidth}px) {
    bottom: -1px;
    left: 10px;
    transform: rotate(-90deg);
  }
`

const iconStyle = {
  fontSize: '20px',
  textAlign: 'center' as 'center',
  lineHeight: '40px',
  width: '100%'
}

interface IProps {}

interface IState {
  isOpen: boolean
}

const SidebarToggleControl = class extends IEventedComponent<IProps, IState> {
  state = {
    isOpen: true
  }

  componentDidMount() {
    this.subscribe(messageTypes.onSidebarToggled, this.handleSidebarToggled.bind(this))
  }

  handleSidebarToggled = () => {
    this.setState((state: any, props: any) => ({
      isOpen: !state.isOpen
    }))
  }

  onClick = () => {
    this.publish<SidebarToggledEvent>(messageTypes.onSidebarToggled, {})
  }

  render() {
    return (
      <ToggleContainer onClick={this.onClick}>
        {this.state.isOpen ? (
          <IconControl icon="chevron-left" style={iconStyle} />
        ) : (
          <IconControl icon="chevron-right" style={iconStyle} />
        )}
      </ToggleContainer>
    )
  }
}

export default SidebarToggleControl
